
import * as dat from 'dat.gui';

class ControllerGUI {
    constructor() {
        this.Values = null
        this.gui = new dat.GUI({ load: {
            "closed": false,
            "remembered": {
             "undefined": {
              "0": {
               "arrival_speed": 0.8,
               "arrival_stagger": 40,
               "departure_speed": 0.35,
               "departure_stagger": 20,
               "enter_scale_force": 10,
               "leave_scale_force": 1,
               "font_transition_enter": false,
               "font_transition_leave": false,
               "transition_enter": 1,
               "transition_leave": "0"
              },
              "1": {
               "arrival_speed": 0.8,
               "arrival_stagger": 40,
               "departure_speed": 0.35,
               "departure_stagger": 20,
               "enter_scale_force": 10,
               "leave_scale_force": 1,
               "font_transition_enter": false,
               "font_transition_leave": false,
               "transition_enter": 1,
               "transition_leave": "0"
              },
              "2": {
               "enabled": true,
               "enabled_skew_horizontal": false,
               "enabled_scale_horizontal": false,
               "enabled_scale_vertical": true,
               "force": 1.5,
               "inertia": 0.06,
               "force_skew": 0.5,
               "reverse": false,
               "reverse_skew": false
              }
             }
            },
            "folders": {
             "Directors": {
              "preset": "Default",
              "closed": true,
              "folders": {}
             },
             "News": {
              "preset": "Default",
              "closed": true,
              "folders": {}
             },
             "Scroll": {
              "preset": "Default",
              "closed": true,
              "folders": {}
             }
            }
           } });

        this.DirectorsValues()
        this.DirectorsGUI()

        this.NewsValues()
        this.NewsGUI()

        this.ScrollValues()
        this.ScrollGUI()
        
        this.MenuValues()
        //this.MenuGUI()

        this.log()

        if(window.location.hash === '#debug') this.gui.show()
        else this.gui.hide()

        this.gui.close()
        
        
    }

    DirectorsValues() {
        let Directors  = function() {
            this.arrival_speed = 0.5;
            this.arrival_stagger = 40;

            this.departure_speed = 0.8;
            this.departure_stagger = 50;

            this.enter_scale_force = 50;
            this.leave_scale_force = 0.5;

            this.font_transition_enter = true;
            this.font_transition_leave = false;

            this.transition_enter = 1;
            this.transition_leave = 1;
        };

        this.Directors = new Directors();
        this.gui.remember(this.Directors)
    }

    DirectorsGUI() {
        this.directors = this.gui.addFolder('Directors');

        this.directors.add(this.Directors, 'arrival_speed', 0, 2);
        this.directors.add(this.Directors, 'arrival_stagger', 0, 200);

        this.directors.add(this.Directors, 'departure_speed', 0, 2);
        this.directors.add(this.Directors, 'departure_stagger', 0, 200);

        this.directors.add(this.Directors, 'enter_scale_force', 1, 150);
        this.directors.add(this.Directors, 'leave_scale_force', 0.1, 50);


        this.directors.add(this.Directors, 'font_transition_enter');
        this.directors.add(this.Directors, 'font_transition_leave');

        this.directors.add(this.Directors, 'transition_enter', {EaseIn : 0, EaseOut : 1, EaseInOut : 2, Bounce : 3} );
        this.directors.add(this.Directors, 'transition_leave', {EaseIn : 0, EaseOut : 1, EaseInOut : 2, Bounce : 3} );
    }


    NewsValues() {
        let News  = function() {
            this.arrival_speed = 0.5;
            this.arrival_stagger = 40;

            this.departure_speed = 0.8;
            this.departure_stagger = 50;

            this.enter_scale_force = 50;
            this.leave_scale_force = 0.5;

            this.font_transition_enter = true;
            this.font_transition_leave = false;

            this.transition_enter = 1;
            this.transition_leave = 1;
            
        };

        this.News = new News();
        this.gui.remember(this.News)
    }

    NewsGUI() {
        this.news = this.gui.addFolder('News');

        this.news.add(this.News, 'arrival_speed', 0, 2);
        this.news.add(this.News, 'arrival_stagger', 0, 200);

        this.news.add(this.News, 'departure_speed', 0, 2);
        this.news.add(this.News, 'departure_stagger', 0, 200);

        this.news.add(this.News, 'enter_scale_force', 1, 150);
        this.news.add(this.News, 'leave_scale_force', 0.1, 50);

        this.news.add(this.News, 'font_transition_enter');
        this.news.add(this.News, 'font_transition_leave');

        this.news.add(this.News, 'transition_enter', {EaseIn : 0, EaseOut : 1, EaseInOut : 2, Bounce : 3} );
        this.news.add(this.News, 'transition_leave', {EaseIn : 0, EaseOut : 1, EaseInOut : 2, Bounce : 3} );
    }

    ScrollValues() {
        let Scroll  = function() {
            this.enabled = true;
            this.enabled_skew_horizontal = false;
            this.enabled_scale_horizontal = false;
            this.enabled_scale_vertical = true;
            this.force = 1.5;
            this.inertia = 0.05;
            this.reverse = false;
            this.force_skew = 0.5
            this.reverse_skew = false;
        };

        this.Scroll = new Scroll();
        this.gui.remember(this.Scroll)
    }
    
    ScrollGUI() {
        this.scroll = this.gui.addFolder('Scroll');
        this.scroll.add(this.Scroll, 'enabled');
        this.scroll.add(this.Scroll, 'enabled_skew_horizontal');
        this.scroll.add(this.Scroll, 'enabled_scale_horizontal');
        this.scroll.add(this.Scroll, 'enabled_scale_vertical');
        this.scroll.add(this.Scroll, 'force', 0, 2);
        this.scroll.add(this.Scroll, 'inertia', 0.01, 0.2);
        this.scroll.add(this.Scroll, 'force_skew', 0, 5);
        this.scroll.add(this.Scroll, 'reverse');
        this.scroll.add(this.Scroll, 'reverse_skew');
        
    }

    MenuValues() {
        let Menu  = function() {
            this.scaleDuration = 1.2;
            this.fontDuration = 0.8;
            this.transition_scale = 2;
        };

        this.Menu = new Menu();
        this.gui.remember(this.Menu)
    }
    
    MenuGUI(cb) {
        this.menu = this.gui.addFolder('Menu');
        this.menu.add(this.Menu, 'scaleDuration', 0, 2);
        this.menu.add(this.Menu, 'transition_scale', {EaseIn : 0, EaseOut : 1, EaseInOut : 2, Linear: 3} );
        this.menu.add(this.Menu, 'fontDuration', 0, 2).onChange(cb);
        
    }

    log() {
        console.log("    ____  _ _____                      ");
        console.log("   / __ \(_) / (_)___  ____ ____  _____");
        console.log("  / / / / / / / / __ \/ __ `/ _ \/ ___/");
        console.log(" / /_/ / / / / / / / / /_/ /  __/ /    ");
        console.log("/_____/_/_/_/_/_/ /_/\__, /\___/_/     ");
        console.log("                    /____/             ");
    }

}

let GUI = new ControllerGUI();

export default GUI